const PROMPT_PREFIXES = ["select", "enter", "choose", "add", "upload"];

export const getSensitiveDataFieldLabel = (key: string): string => {
  const [firstWord, ...rest] = key.trim().split(" ");

  if (rest.length === 0) return key;
  if (!PROMPT_PREFIXES.includes(firstWord.toLowerCase())) return key;

  const remainder = rest.join(" ");

  return remainder.charAt(0).toUpperCase() + remainder.slice(1);
};
